import { Typography } from '@mui/material'
import { useStyles } from './EmptyState.styles'
import { ButtonV2 } from '@labrav/react-components'
// SupportTicketButton uses the public help-center URL; kept out of the app constant module.
const labraSubmitSupportTicket =
  'https://helpcenter.labra.io/hc/en-us/requests/new'
type EmptyState = {
  imgSrc?: string
  header?: string
  content?: JSX.Element
  action?: JSX.Element
}
export const EmptyState = ({ imgSrc, header, content, action }: EmptyState) => {
  const { classes } = useStyles()
  return (
    <div className={classes.emptyProductContainer} data-testid="empty-state">
      <div className={classes.emptyProductInnerContainer}>
        <div className={classes.leftContainer} data-testid="image-container">
          <img
            className={classes.thumbnailImages}
            src={imgSrc}
            alt={'empty-state'}
          />
        </div>
        <div className={classes.rightContainer}>
          <Typography className={classes.heading}>{header}</Typography>
          {content}
          {action}
        </div>
      </div>
    </div>
  )
}

export const SupportTicketButton = () => {
  const { classes } = useStyles()
  const onClickSubmit = () => window.open(labraSubmitSupportTicket)
  return (
    <ButtonV2
      data-testid={'submit-support-ticket'}
      className={classes.submitButton}
      onClick={onClickSubmit}
    >
      Submit a support ticket
    </ButtonV2>
  )
}
